if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.hasAttribute('data-notify-me')) {
          // Open the Klaviyo popup form
          if (window._klOnsite) {
            window._klOnsite.push(['openForm', 'XKnJMv']);
          }
          return;
        }
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              // Shopify can partially add stock and still return an error status
              // (e.g. "Only N items were added ... due to availability."). In that case the
              // cart changed server-side but this branch never re-renders it, so refresh +
              // open the drawer/notification so the added items show without a page reload.
              if (this.cart) {
                const sectionIds = this.cart.getSectionsToRender().map((section) => section.id);
                fetch(`${routes.cart_url}?sections=${sectionIds.join(',')}`)
                  .then((cartResponse) => cartResponse.json())
                  .then((sections) => {
                    this.cart.renderContents({ sections: sections });
                  })
                  .catch((e) => console.error(e));
              }

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text, preorder = null) {
        const buyNowBtn = this.querySelector('.product-buy-now');
        // `preorder` is null when the caller can't know yet (the optimistic
        // client-side path, before the section HTML comes back). Keep whatever the
        // last server render decided so the label doesn't flicker between
        // "Preorder Now" and "Add to cart".
        const isPreorder = preorder === null ? this.submitButton.hasAttribute('data-preorder') : preorder;

        if (disable) {
          this.submitButton.removeAttribute('disabled');
          this.submitButton.removeAttribute('data-preorder');
          this.submitButton.setAttribute('data-notify-me', '');
          this.submitButtonText.textContent = 'Notify Me';
          // Swap Buy it now → Shop Similar
          if (buyNowBtn) {
            buyNowBtn.removeAttribute('data-buy-now');
            buyNowBtn.setAttribute('data-shop-similar', '');
            const span = buyNowBtn.querySelector('span');
            if (span) span.textContent = 'Shop Similar';
          }
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButton.removeAttribute('data-notify-me');
          this.submitButton.toggleAttribute('data-preorder', isPreorder);
          this.submitButtonText.textContent = isPreorder ? 'Preorder Now' : window.variantStrings.addToCart;
          // Swap Shop Similar → Buy it now
          if (buyNowBtn) {
            buyNowBtn.removeAttribute('data-shop-similar');
            buyNowBtn.setAttribute('data-buy-now', '');
            const span = buyNowBtn.querySelector('span');
            if (span) span.textContent = window.variantStrings.buyNow || 'Buy it now';
          }
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
